export default "__VITE_ASSET__81c3b3ed__"